import { ProductIdentifier } from 'components/common/types/DirectSalesProductTemplate.types';

export const sortProducts = (products: ProductIdentifier[]): ProductIdentifier[] => {
  return [...products].sort((a, b) => {
    const folderComparison = a.folder.localeCompare(b.folder);
    const templateComparison = a.name.localeCompare(b.name);

    return folderComparison === 0 ? templateComparison : folderComparison;
  });
};
